module.exports = __webpack_public_path__ + "static/media/strokecolor.4c2f0aae.svg";